import React from "react"
import {makeAutoObservable} from "mobx"


class ThemeState {
    cursor = "none"

    chat_panel_form_flex_direction = 0
    rowDir= ["row","row-reverse"]
    flexDir = ["flex-start","flex-end"]
    // https://coolors.co/98c1d9-191923-bf1363-e0fbfc-eb4511
    colour_primary = "#0D3B66" // Nice blue-ish colour
    colour_primary_light = "#1e4366"
    colour_secondary = "#5299D3"
    colour_tertiary = "#A4031F"
    colour_quartiary = "#000000"

    colour_time_up = "#A4031F"
    colour_within_time = "#20BF55"

    colour_text = "#EEEEEE"
    colour_primary_name = "blauwe"

    chat_text_feedback = 16



    constructor() {
        makeAutoObservable(this);
    }

    switchRow() {
        this.chat_panel_form_flex_direction = this.chat_panel_form_flex_direction ^ 1
    }

    display_mouse_gravity = false;

    toggleDisplayMouseGravity() {
        this.display_mouse_gravity ^= 1;
    }
}

const themeState = new ThemeState();

export default themeState;